import React, { useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Paper } from "@material-ui/core";
import { Title } from "App/Component/ui";
import { FormMT, RenderListReq } from "./ui";

import { FormContext, FormProvider } from "./context/FormContext";
import { getMaintenanceData } from "./helpers";
import { WMS_FA_INPUT_MAINTENANCE } from "App/constants";
import { isNull } from "App/utils/helpers";
import { RenderStatusVerifikasiBadge } from "../DaftarMaintenance/helpers";

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function InputMaintenance(props) {
  const classes = useStyles();
  const { data, menu } = props;
  return (
    <FormProvider data={data} menu={menu}>
      <div className={classes.root}>
        <RenderContent
          classes={classes}
          data={menu === WMS_FA_INPUT_MAINTENANCE ? data : null}
        />
      </div>
    </FormProvider>
  );
}

const RenderContent = ({ classes, data }) => {
  const { setFilePDF, formData, setFormData, setDetailMT } =
    useContext(FormContext);

  useEffect(() => {
    setNewData(data?.id);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (id) => {
    await getData(id);
  };

  const getData = async (id) => {
    if (!isNull(id)) {
      const res = await getMaintenanceData(id);
      if (res.state) {
        // if (!isNull(res.data.id_helpdesk_header)) {
        //   const helpDesk = await getReqListById(res.data.id_helpdesk_header);
        //   if (helpDesk.state) {
        //     setListDetail(listDetail.detail);
        //   } else {
        //     defaultToastError(listDetail.message);
        //     setListDetail([]);
        //   }
        // }
        setFormData(res.data);
        setDetailMT(res.detail);
        setFilePDF(res.data_file);
      } else {
        setDetailMT([]);
        setFilePDF([]);
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // marginBottom: "1rem",
        }}>
        <Title title={"Input Maintenance"} />
        {formData?.id !== "" ? (
          <div>
            <RenderStatusVerifikasiBadge status={formData?.status_service} />
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <Paper className={classes.paper}>
        <FormMT data={data} setNewDataReqList={setNewData} />
        <div className='mt-2'></div>
        {/* {listDetail.length > 0 && (
        <ListDetail
          setNewDataReqList={setNewData}
          formData={formData}
          listDetail={listDetail}
        />
      )} */}
        {!isNull(formData.id) && (
          <RenderListReq classes={classes} setNewDataReqList={setNewData} />
        )}
      </Paper>
    </>
  );
};
